import './AboutMumulyaPage.css';
import Cover from "../../components/Cover/Cover";
import coverImage from "../../assets/images/mainCoverImage.webp";
import coverImageMobile from "../../assets/images/mainCoverImageMobile.webp";
import aboutMumulyaImageOne from "../../assets/images/aboutMumulyaImageOne.webp";
import aboutMumulyaImageTwo from "../../assets/images/aboutMumulyaImageTwo.webp";
import aboutMumulyaImageThree from "../../assets/images/aboutMumulyaImageThree.webp";

const AboutMumulyaPage = () => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;
  return (
    <div className='page'>
      <title>Про ТМ «Мумуля» — натуральні молочні продукти з любов’ю</title>
      <meta name="description" content={"Дізнайтесь більше про ТМ «Мумуля» — бренд, що створює смачні та корисні молочні продукти для всієї родини. Молоко, йогурти, сирки, сметана та масло — усе з любов’ю, як для своїх."}/>
        <Cover text={"“Мумуля” — це завжди смачно!"} src={coverImageToUse} />
        <section className="about__mumulya-production">
        <div className="about__mumulya-production-wrapper">
          <div className="about__mumulya-production-texts">
            <h1 className="about__mumulya-production-title mont-m">
            Мумуля! Му-му-му!
            </h1>
            <p className="about__mumulya-production-text int-r-21">
            Молоко — це перший продукт, який потрібен усім для життя, росту та здоров’я, і ТМ «Мумуля» добре це знає.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Наша Мумуля — з дипломом харчового інституту, з ідеями кухаря-кулінара, турботливим серцем мами та амбіціями блогерки-мільйонниці.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Вона знає, коли молоко має бути теплим, а коли охолодженим, як зробити йогурт густим, сирок — ніжним, а ряжанку — оксамитовою.
            </p>
          </div>
          <img
            src={aboutMumulyaImageOne}
            alt="Виробництво Миколаївмолпром"
            className="about__mumulya-production-image"
          />
        </div>
        <div className="about__mumulya-production-wrapper reversed">
          <div className="about__mumulya-production-texts">
            <h3 className="about__mumulya-production-subtitle mont-m">
            Мумуля знає про молоко
            </h3>
            <p className="about__mumulya-production-text int-r-21">
            А головне — Мумуля знає, як нагодувати всю родину так, щоб і смачно, і корисно, і ще трошки «на потім» залишилось.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Для дітей — натуральне молоко та сирок для розвитку кісточок.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Для підлітків — смачні йогурти та желе.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Мамі — кефір для стрункості.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Батькові — сметану для борщу та пельменів.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Бабусям і дідусям — вершкове масло, яке вони так люблять намазувати на булочку з домашнім варенням. Смакота!
            </p>
            <p className="about__mumulya-production-text int-r-21">
            А що до вподоби вам? Плавлений сирок? А може, сметанковий десерт?
            </p>
          </div>
          <img
            src={aboutMumulyaImageTwo}
            alt="Виробництво Миколаївмолпром"
            className="about__mumulya-production-image two"
          />
        </div>
        <div className="about__mumulya-production-wrapper">
          <div className="about__mumulya-production-texts">
            <h3 className="about__mumulya-production-subtitle mont-m">
            Мумуля — лагідна, як мама
            </h3>
            <p className="about__mumulya-production-text int-r-21">
            ТМ «Мумуля» — це народний бренд, він поруч із нами.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Молочна корівка Мумуля «прописана» в Південному регіоні України — на Доманівському маслосирзаводі.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Але робочого халата не носить, бо частенько гуляє духмяними луками, щоб дати поживне молоко для заводу.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Керує технологічними процесами просто з лугу, а на заводі буває ввечері — щоб вигадувати рецепти нових сирочків та йогуртів.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Кажуть, якщо тихо-тихо відкрити холодильник — можна почути ніжне «Му-му-му», бо МУМУЛЯ поруч.
            </p>
            <p className="about__mumulya-production-text int-r-21">
            Мумуля — лагідна, як мама. І не забудьте подякувати. Бо Мумуля — це завжди смачно!
            </p>
          </div>
          <img
            src={aboutMumulyaImageThree}
            alt="Виробництво Миколаївмолпром"
            className="about__mumulya-production-image three"
          />
        </div>
      </section>
    </div>
  )
}

export default AboutMumulyaPage